module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-habanero.c26c99a4.png";